var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { defineCustomElement } from "../utils/defineCustomElement.js";
import {
  Window as window,
  Document as document
} from "../utils/server-safe-globals.js";
class MediaTheme extends window.HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    this.render();
  }
  render() {
    this.shadowRoot.textContent = "";
    const template = document.createElement("template");
    template.innerHTML = this.constructor.template;
    this.shadowRoot.append(template.content.cloneNode(true));
  }
  get mediaController() {
    return this.shadowRoot.querySelector("media-controller");
  }
}
__publicField(MediaTheme, "template", "");
defineCustomElement("media-theme", MediaTheme);
var media_theme_default = MediaTheme;
export {
  media_theme_default as default
};
